import React, {useEffect} from 'react';
import {Link, useHistory} from 'react-router-dom';
import {authPath, rootMainPath} from '../../routes/paths';
import ButtonMUI from '../../shared/ButtonMUI';

import SuccessfullyBg from '../../assets/images/auth/Successfully.jpg';
import {useTranslation} from 'react-i18next';

const Successfully = () => {
  const {t} = useTranslation();
  const history = useHistory();

  useEffect(() => {
    localStorage.getItem('token') && history.push(rootMainPath);
  }, []);

  return (
    <div className='auth-page__content'>
      <div className='auth-page__bg'>
        <img className='employee' src={SuccessfullyBg} alt='AuthBg' />
      </div>
      <div className='auth-box__wrapper successfully'>
        <div className='auth-box successfully'>
          <div className='auth-box__title'>Дякуємо за реєстрацію!</div>
          <div className='auth-box__descriptions'>
            Підтвердження буде надіслано на вашу електронну адресу після перевірки модератором.
          </div>

          <ButtonMUI component={Link} to={authPath.signIn}>
            Закрити
          </ButtonMUI>
        </div>

        <div className='auth-box__subscribe successfully__subcribe'>
          {t('SideBgFooter.copyright', {year: new Date().getFullYear()})}
        </div>
      </div>
    </div>
  );
};

export default Successfully;
